import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as t}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as i}from"../../icon-registry.js";const p=i("south_africa",t`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5H24V12.5H12L0 4.5Z"
                fill="#E03C31" />
            <path
                d="M0 20.5H24V12.5H12L0 20.5Z"
                fill="#001489" />
            <path
                d="M24 9.83333H12.808L4.808 4.5H0V20.5H4.808L12.808 15.1667H24V9.83333Z"
                fill="white" />
            <path
                d="M0 20.5L12 12.5L0 4.5V7.70533L7.192 12.5L0 17.2947V20.5Z"
                fill="#FFB81C" />
            <path
                d="M24 10.9H12.4853L2.88533 4.5H0V6.42267L9.11467 12.5L0 18.5773V20.5H2.88533L12.4853 14.1H24V10.9Z"
                fill="#007749" />
        </svg>
    `),d=i("south_africa_rounded",t`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19477_118302)">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="#FF4E4E" />
                <path
                    d="M-6 0.5H30V12.5H12L-6 0.5Z"
                    fill="#E03C31" />
                <path
                    d="M-6 24.5H30V12.5H12L-6 24.5Z"
                    fill="#001489" />
                <path
                    d="M30 8.5H13.212L1.212 0.5H-6V24.5H1.212L13.212 16.5H30V8.5Z"
                    fill="white" />
                <path
                    d="M-6 24.5L12 12.5L-6 0.5V5.308L4.788 12.5L-6 19.692V24.5Z"
                    fill="#FFB81C" />
                <path
                    d="M30 10.1H12.728L-1.672 0.5H-6V3.384L7.672 12.5L-6 21.616V24.5H-1.672L12.728 14.9H30V10.1Z"
                    fill="#007749" />
            </g>
            <defs>
                <clipPath id="clip0_19477_118302">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `),f=i("ZAR",t`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19477_118302)">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="#FF4E4E" />
                <path
                    d="M-6 0.5H30V12.5H12L-6 0.5Z"
                    fill="#E03C31" />
                <path
                    d="M-6 24.5H30V12.5H12L-6 24.5Z"
                    fill="#001489" />
                <path
                    d="M30 8.5H13.212L1.212 0.5H-6V24.5H1.212L13.212 16.5H30V8.5Z"
                    fill="white" />
                <path
                    d="M-6 24.5L12 12.5L-6 0.5V5.308L4.788 12.5L-6 19.692V24.5Z"
                    fill="#FFB81C" />
                <path
                    d="M30 10.1H12.728L-1.672 0.5H-6V3.384L7.672 12.5L-6 21.616V24.5H-1.672L12.728 14.9H30V10.1Z"
                    fill="#007749" />
            </g>
            <defs>
                <clipPath id="clip0_19477_118302">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{p as SouthAfrica,d as SouthAfricaRounded,f as ZAR};
